export var BackendType;
(function (BackendType) {
    BackendType["TT"] = "tt";
    BackendType["WX"] = "wx";
    BackendType["MY"] = "my";
    BackendType["SWAN"] = "swan";
})(BackendType || (BackendType = {}));
export var AppMethod;
(function (AppMethod) {
    AppMethod["onLaunch"] = "onLaunch";
    AppMethod["onShow"] = "onShow";
    AppMethod["onHide"] = "onHide";
    AppMethod["onError"] = "onError";
    AppMethod["onUnhandledRejection"] = "onUnhandledRejection";
    AppMethod["onPageNotFound"] = "onPageNotFound";
})(AppMethod || (AppMethod = {}));
export var PageMethod;
(function (PageMethod) {
    PageMethod["onLoad"] = "onLoad";
    PageMethod["onShow"] = "onShow";
    PageMethod["onReady"] = "onReady";
    PageMethod["onHide"] = "onHide";
    PageMethod["onUnload"] = "onUnload";
    PageMethod["onPullDownRefresh"] = "onPullDownRefresh";
})(PageMethod || (PageMethod = {}));
export var SDKMethod;
(function (SDKMethod) {
    SDKMethod["request"] = "request";
})(SDKMethod || (SDKMethod = {}));
//# sourceMappingURL=types.js.map